import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateMarkAnimationSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateMarkAnimationSettingRequest extends Request<IUpdateMarkAnimationSettingParams, IResult> {
  constructor(params: IUpdateMarkAnimationSettingParams) {
    super('updateMarkAnimationEnabledSetting', params);
  }
}
